export class DependentGrid {
	dependents: DependentGridList[];

	constructor() {
		this.dependents = new Array<DependentGridList>();
	}
}

export class DependentGridList {
	dependentID?: number;
	dependentName: string;
	dependentSsn: string;
	dependentDateOfBirth: string;
	dependentAge: number;
	dependentGender: string;
	dependentRelationship: string;
	systemNumber?: number;
	dependentIsVerified: boolean;
	dependentIsVerifiedIsPending: boolean;
	dependentHasVerificationDocuments: boolean;
	spouseSSNRequired: boolean;
	isEditable: boolean;
	isDemographicsEditable: boolean;
	disabledMessage: string;

	constructor() {
		this.dependentID = 0;
		this.dependentName = '';
		this.dependentSsn = '';
		this.dependentDateOfBirth = '';
		this.dependentAge = 0;
		this.dependentRelationship = '';
		this.dependentGender = '';
		this.systemNumber = 0;
		this.dependentIsVerified = false;
		this.dependentIsVerifiedIsPending = false;
		this.dependentHasVerificationDocuments = false;
		this.spouseSSNRequired = false;
		this.isEditable = false;
		this.isDemographicsEditable = false;
		this.disabledMessage = '';
	}
}

export class DependentGridVerifyDetail extends DependentGridList {
	verifcationStatus: string;
	requiresDocuments: boolean;

	constructor() {
		super();
		this.verifcationStatus = null;
		this.requiresDocuments = false;
	}
}

export class DependentDocumentsStautsPayload {
	id: number;

	constructor() {
		this.id = 0;
	}
}

export class DependentDocumentsStatusModel {
	dependentName: string;
	documents: DependentDocumentsStatus[];

	constructor(){
		this.dependentName = null;
		this.documents = new Array<DependentDocumentsStatus>();
	}
}

export class DependentDocumentsStatus {
	documentID: number;
	documentName: string;
	receivedDate: string;
	reviewedDate: string;
	documentIsPending: boolean;
	documentIsRejected: boolean;
	documentIsVerified: boolean;

	constructor(){
		this.documentID = 0;
	}
}